export default __webpack_public_path__ + "static/media/addUserImage.f434dfe6.png";